"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Policy = /** @class */ (function () {
    function Policy() {
    }
    return Policy;
}());
exports.default = Policy;
//# sourceMappingURL=Policy.js.map